<template>
    <Modal ref="baseModal">
        <div class="modal-inner">
            <div class="modal-body">
                <h3>입사지원을 하였습니다.</h3>
                <p class="red mt-sm">
                  지원 완료된 이력서는 수정이 불가하며,<br/>
                  제출한 이력서를 변경하고 싶으신 경우<br/>
                  입사지원 취소 후 새로운 이력서로 다시<br/>
                  지원할 수 있습니다.
                </p>
            </div>
            <div class="modal-footer">
                <KSAPrimaryButton class="full-btn" text="확인" @click="close" />
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import { ref } from "vue";

export default {
    name: "ConfirmModal",
    components: {
        Modal,
    },
    setup() {
        const baseModal = ref(null);
        const resolvePromise = ref(null);

        const show = () => {
            baseModal.value.open();

            return new Promise((resolve, _) => {
                // resolve 함수를 담아 외부에서 사용합니다.
                resolvePromise.value = resolve;
            });
        };

        const close = () => {
            baseModal.value.close();
            resolvePromise.value(true);
        };
        return { baseModal, show, close };
    },
};
</script>

<style lang="scss" scoped>
    @import "../../../../../assets/scss/theme";

    .red {
      color: $red_color !important;
    }
</style>